export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();

  if (!authStore.isPartner) {
    return await navigateTo({
      path: "/",
    });
  }
});
